import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
query MarketNewsListing {
    allPrismicCompanyNews {
      nodes {
        data {
          date {
            text
          }
          description {
            spans {
              data {
                link_type
                url
              }
              end
              start
              type
            }
            text
            type
          }
          image_big {
            url
          }
          image_small {
            url
          }
          read_more_label {
            text
          }
          title {
            text
          }
        }
        lang
      uid
      }
    }
  }
  
  
`

const dataResolver = (response, lang) => {
  const { allPrismicCompanyNews } = response
  return allPrismicCompanyNews.nodes.filter(node => node.lang === lang);
}

const useData = lang => {
  const response = useStaticQuery(query)
  return dataResolver(response, lang)
}

export default useData
